import { useTranslation } from 'react-i18next';
import React from 'react';
import SentenceChunk from 'components/SentenceChunk/SentenceChunk';
import {
    getScopeValuesByField,
    hasFilterScope,
} from 'components/SentenceFilter/helpers';
import { cloneDeep } from 'lodash';
import { ScopeT, UserScopesT } from 'business/definitions';
import { styled, Typography } from '@mui/material';
import Flex from 'ui/Flex/Flex';
import { translateBlock } from 'i18n';
import { capitalize } from 'helpers/helpers';
import { AlertFilter } from 'lib/alert/models';
import { getFilterManager } from 'components/Shared/filters/helpers';

type Props = {
    filter: AlertFilter;
    selectedIndex: number;
    changeSelectedChunk: (index: number) => void;
    removeChunk: (index: number) => void;
    changeFilter: (filter: AlertFilter) => void;
    userScopes: UserScopesT;
    scopes: ScopeT[];
};

const StyFilterSentenceChunk = styled(SentenceChunk, {
    name: 'StyFilterSentenceChunk',
})({
    flex: 1,
    '& .filter-operation': {
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
});

const AlertFilterChunk = ({
    filter,
    selectedIndex,
    changeSelectedChunk,
    removeChunk,
    changeFilter,
    userScopes,
    scopes,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const FilterPickerItem = getFilterManager(filter);
    const updateFilter = (fields: Partial<SentenceFilterT>) => {
        changeFilter({ ...filter, ...fields });
    };

    const { displayIndex } = filter;

    /* Adding user scopes to each filter if there is a restricted scope */
    const filterWithScopes: AlertFilter & WithScopes = cloneDeep(filter);
    if (hasFilterScope(filter.field, userScopes, scopes)) {
        filterWithScopes.scopes = getScopeValuesByField(
            filter.field,
            userScopes,
            t,
            scopes,
        );
    }

    return (
        <StyFilterSentenceChunk
            key={`filter-${displayIndex}`}
            displayIndex={displayIndex}
            isSelected={displayIndex === selectedIndex}
            onClick={changeSelectedChunk}
            removeChunk={removeChunk}
            hide={!filter.field}
        >
            <Flex flexWrap="wrap">
                <Typography>
                    {capitalize(translateBlock(filter.field))}
                </Typography>
                {filter.field && filter.type && (
                    <FilterPickerItem
                        filter={filterWithScopes}
                        setFilter={updateFilter}
                        displayIndex={displayIndex}
                    />
                )}
            </Flex>
        </StyFilterSentenceChunk>
    );
};

export default AlertFilterChunk;
